var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndustrialActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9 4.5L21 19.8C21 20.1 20.8 20.4 20.5 20.3H15.9H15.5H10.7V17.7C10.7 17.4 10.5 17.2 10.2 17.2H5.1C4.8 17.2 4.6 17.4 4.6 17.7V20.3H3.5C3.2 20.3 3 20.1 3 19.8V11.4C3 11.1 3.2 10.9 3.5 10.9H4.2V9.7C4.2 9.4 4.4 9.2 4.7 9.2H10.7C11 9.2 11.2 9.4 11.2 9.7V10.9H11.8C12.1 10.9 12.3 11.1 12.3 11.4V16.7H15.7L16.6 4.5C16.6 4.2 16.8 4 17.1 4H19.4C19.6 4 19.9 4.2 19.9 4.5ZM4.1 14C4.1 14.5 4.5 14.9 5 14.9C5.5 14.9 6 14.5 6 14C6 13.5 5.5 13 5 13C4.5 13 4.1 13.5 4.1 14ZM6.7 14C6.7 14.5 7.1 14.9 7.6 14.9C8.1 14.9 8.6 14.5 8.6 14C8.6 13.5 8.1 13 7.6 13C7.1 13 6.7 13.5 6.7 14ZM9.3 14C9.3 14.5 9.7 14.9 10.2 14.9C10.7 14.9 11.2 14.5 11.2 14C11.2 13.5 10.7 13 10.2 13C9.7 13 9.3 13.5 9.3 14ZM6.2002 18.3H9.10019C9.4002 18.3 9.60019 18.5 9.7002 18.8V20.4H5.7002V18.8C5.7002 18.5 5.9002 18.3 6.2002 18.3Z",
    fill: "#273137"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustrialActive);
export default __webpack_public_path__ + "static/media/IndustrialActive.82de41daaef058e27ad99c059ef56cf3.svg";
export { ForwardRef as ReactComponent };